import script from "./InstructionAdmin.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstructionAdmin.vue?vue&type=script&lang=ts&setup=true"

import "./InstructionAdmin.vue?vue&type=style&index=0&id=a007e384&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a007e384"]])

export default __exports__